export const CENTRALIZATION_BYPASS_KEY = 'we-centralization-bypass-until';
export const CENTRALIZATION_BYPASS_TTL_MS = 30_000;
export const CENTRALIZATION_SESSION_BYPASS_KEY = 'we-centralization-session-bypass';
